import React from "react";

export interface SelectOption {
  value: string | number;
  label: React.ReactNode;
  disabled?: boolean;
}

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  className?: string;
  options?: SelectOption[];
  children?: React.ReactNode;
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, options, children, ...rest },
  ref
) {
  const classes = ["ui-input", "ui-select", className].filter(Boolean).join(" ");
  return (
    <select ref={ref} className={classes} {...rest}>
      {options
        ? options.map((option) => (
            <option key={option.value} value={option.value} disabled={option.disabled}>
              {option.label}
            </option>
          ))
        : children}
    </select>
  );
});

export default Select;
